module.exports = __webpack_public_path__ + "img/lentes-movil.aec911e4.png";